/**
 * SubconGuard — route-level gate for SUBCONTRACTORS, blocking the screen
 * BEFORE it mounts so none of the payroll lists are even read.
 *
 * Mounting first and hiding after would fetch bank accounts, TINs and every
 * payout into a browser that is not allowed to see them, which is a leak with
 * a nice UI over it. So this returns the notice instead of the route's
 * children, and the module's bundle is never asked for.
 *
 * NOT A REDIRECT, deliberately, and for the reason HrisGuard gives: bouncing
 * somebody to Home tells them the URL does not exist, which is a different
 * and untrue thing from "you may not open this". See subconAccess.ts for the
 * allowlist, and for why this gates the UI and not the data.
 */
import type { ReactNode } from "react";
import { useSubconAccess } from "./subconAccess";

export function SubconGuard({ children }: { children: ReactNode }): JSX.Element {
  if (useSubconAccess()) return <>{children}</>;
  return (
    <div className="restricted-screen">
      <div className="restricted-icon" aria-hidden="true">🔒</div>
      <div className="restricted-title">Restricted</div>
      <div className="restricted-message">
        SUBCONTRACTORS · Payroll holds what each subcontractor is paid, their bank details and their
        TINs, and is limited to the accounts authorised for it. Contact the owner if you believe you
        should have access.
      </div>
    </div>
  );
}
